import { Navigate, Route, Routes } from 'react-router-dom'
import { AppLayout } from '@/shared/layout/AppLayout.tsx'
import { PipelinesListPage } from '@/features/pipelines/pages/PipelinesListPage.tsx'
import { PipelineRoute } from '@/features/pipelines/pages/PipelineRoute.tsx'
import { PipelineSettingsPage } from '@/features/pipelines/pages/PipelineSettingsPage.tsx'
import { LeadDetailPage } from '@/features/leads/pages/LeadDetailPage.tsx'
import { FlowPage } from '@/features/flows/pages/FlowPage.tsx'
import { SalePage } from '@/features/sale/pages/SalePage.tsx'
import { SalesListPage } from '@/features/sale/pages/SalesListPage.tsx'
import { ManagersPage } from '@/features/managers/pages/ManagersPage.tsx'
import { CalendarPage } from '@/features/calendar/pages/CalendarPage.tsx'
import { MatrixPage } from '@/features/matrix/pages/MatrixPage.tsx'
import { ForecastsPage } from '@/features/forecasts/pages/ForecastsPage.tsx'
import { SettingsPage } from '@/features/settings/pages/SettingsPage.tsx'
import { AuditsListPage } from '@/features/audits/pages/AuditsListPage.tsx'
import { AuditPage } from '@/features/audits/pages/AuditPage.tsx'
import { CardPage } from '@/features/audits/pages/CardPage.tsx'
import { ReviewPage } from '@/features/audits/pages/ReviewPage.tsx'
import { ChatPage } from '@/features/audits/pages/ChatPage.tsx'

export function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Navigate to="pipelines" replace />} />
        <Route path="pipelines" element={<PipelinesListPage />} />
        <Route path="pipelines/:pipelineId" element={<PipelineRoute />} />
        <Route path="pipelines/:pipelineId/settings" element={<PipelineSettingsPage />} />
        <Route path="pipelines/:pipelineId/leads/:leadId" element={<LeadDetailPage />} />
        <Route path="audits" element={<AuditsListPage />} />
        <Route path="audits/:auditId" element={<AuditPage />} />
        <Route path="audits/:auditId/cards/:cardId" element={<CardPage />} />
        <Route path="audits/:auditId/review" element={<ReviewPage />} />
        <Route path="audits/:auditId/chat" element={<ChatPage />} />
        <Route path="pipelines/:pipelineId/flows/:flowId" element={<FlowPage />} />
        {/* Its own top-level path, not nested under a pipeline: a sale spans
            boards, so nesting it would force a caller to already know which
            board to ask — the question the page exists to answer. */}
        <Route path="sales" element={<SalesListPage />} />
        <Route path="sales/:ludusLeadId" element={<SalePage />} />
        <Route path="managers" element={<ManagersPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="matrix" element={<MatrixPage />} />
        <Route path="forecasts" element={<ForecastsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  )
}
